module.exports = __webpack_public_path__ + "img/alldone.4252a64b.svg";